// extracted by mini-css-extract-plugin
export default {"buttons":"AddSalary_buttons__NeUzG"};